'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.downloadLinkWidget = function (navigatorModel) {
	return mmWidgets.each(this, function () {
		const element = this;
		if (!navigatorModel.isDownloadSupported()) {
			element.attr('target', '_blank');
		}
	});
};
